import { Component, OnDestroy, OnInit } from '@angular/core';
import { BreakpointService } from "../../../../projects/say-design-system/src/lib/services/breakpoint/breakpoint.service";
import { Subscription } from "rxjs";

@Component({
    selector: 'app-breakpoints-page',
    templateUrl: './breakpoints-page.component.html',
    styleUrls: ['./breakpoints-page.component.scss']
})
export class BreakpointsPageComponent implements OnInit, OnDestroy {

    public currBreakpoint: string;
    private sub$: Subscription;

    constructor(private breakpointService: BreakpointService) {
    }

    ngOnInit() {
        this.sub$ = this.breakpointService.getBreakpoint().subscribe(
            breakpoint => {
                this.currBreakpoint = breakpoint;
            }
        )
    }

    ngOnDestroy() {
        this.sub$.unsubscribe();
    }
}
